/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace component-selector component-class-suffix */

import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit
}                               from '@angular/core';

import {IdeService}             from '@/services/ide.service';
import {UUIDService}            from '@/services/uuid.service';
import {LineSimService}         from '@/services/line.sim.service';
import {AlertService}           from '@/services/alert.service';
import {SimulationGroupElement} from '@/models/project/simulation.group.element';
import {BlobElement}            from '@/models/project/blob.element';
import {Logger}                 from '@/util/logger';
import {SimConfig}              from '@/models/sim/sim.config';
import {ProjectElement}         from '@/models/project/project.element';
import {ProjectElementType}     from '@/models/project/project.element.type';
import {LineSimJobElement}      from '@/models/project/line.sim.job.element';


import {Subscription}           from 'rxjs';

import * as $ from 'jquery';
import 'gasparesganga-jquery-loading-overlay';

import {basename, errorAsText} from '@/util/util';
import {asISO8601}              from '@/util/util';
import {ActionService}          from "@/services/action.service";
import {SimpleSimAction}        from "@/actions/simple.sim.action";
import {SimpleDebugAction}      from "@/actions/simple.debug.action";
import {InputsElement}          from "@/models/project/inputs.element";
import {DimensionElement}       from "@/models/project/dimension.element";
import {BlobType}               from "@/models/blob";
import {ServerSideService} from "@/services/server.side.service";
import {first} from "rxjs/operators";


@Component({
  selector:    '.sim-button',
  template: `
    <div class="sim-run-wrapper">

      <!-- the actual run button -->

      <button
        id="simulationbutton"
        class="gui-button {{this.activeClass}}"
        [class.busy]="this.isBusy() === true "
        (click)="onClick()">
        <i class="fas fa-play simulation-button-icon {{this.activeClass}}" ></i>
        <span class="simulation-button-title {{this.activeClass}}" >{{this.simulationTitle}}</span>

      </button>

      <button
        id="debugbutton"
        class="gui-button {{this.activeDebugClass}}"
        style="margin-left: 8px;"
        [class.busy]="this.isBusy() === true "
        (click)="onClick(true)">
        <i class="fas fa-bug debug-button-icon {{this.activeDebugClass}}" ></i>

      </button>

      <!-- simulator selection -->

      <select
        id="simSelector"
        class="custom-select sim-dispatch"
        style="cursor: pointer;"
        (change)="selectSimulator($event); reconfigure()"
        title="Select a remote simulator NOT for Debug">

      </select>

      <!-- the quick config options -->

      <div class="sim-run-config-wrapper form-group">

        <span (click)="toggleOptionsPanel()" class="gui-label" style="cursor: pointer; color: #BBBBBB; margin-left: 8px; margin-bottom: 0; margin-top: 6px; font-size: 10px; font-weight: normal; padding-right: 8px;">
          <label style="display: inline-block; cursor: pointer; ">Options</label>
          <span style="margin-left: 4px; font-size: 9px;" class="p-button-icon pi pi-angle-down" aria-hidden="true"></span>
        </span>

        <div class="dropmenu drop-startend-details" style="float: right; margin-left: 6px; margin-right: 24px; cursor: pointer; left: 550px;">

          <div class="dropmenu-down-content right" [class.active]="showOptions" style="padding: 0; width: 640px; display: flex; ">

            <div style="flex: 50%;">

              <div style="height: 20px;"></div>

              <div style="padding: 8px; width: 320px;">

                <span style="width: 45px; display: inline-block;">
                  <mat-label

                    matTooltip="Use the start and end times to bracket (create a window) when user logging data will be captured.  Only applies in Debug mode.  Maximum of 5 days from start time."
                    matTooltipPosition="below"
                    matTooltipHideDelay="2000"
                    matTooltipClass="hover-tooltip"
                  >
                    Log start:

                  </mat-label>
                </span>
                <p-inputNumber title="Day"    suffix="d" id="ulstin-day"  class="startendinput" [(ngModel)]="tsDays"  mode="decimal" value="0" showButtons="true" buttonLayout="vertical" min="0" max="999" width="40"></p-inputNumber>
                <p-inputNumber title="Hour"   suffix="h" id="ulstin-hour" class="startendinput" [(ngModel)]="tsHours" mode="decimal" value="0" showButtons="true" buttonLayout="vertical" min="0" max="24"  width="40"></p-inputNumber>
                <p-inputNumber title="Minute" suffix="m" id="ulstin-min"  class="startendinput" [(ngModel)]="tsMins"  mode="decimal" value="0" showButtons="true" buttonLayout="vertical" min="0" max="59"  width="40"></p-inputNumber>
                <p-inputNumber title="Second" suffix="s" id="ulstin-sec"  class="startendinput" [(ngModel)]="tsSecs"  mode="decimal" value="0" showButtons="true" buttonLayout="vertical" min="0" max="59"  width="40"></p-inputNumber>
              </div>

              <div style="padding: 8px; width: 320px;">

                <span style="width: 45px; display: inline-block;">
                  <mat-label

                    matTooltip="Use the start and end times to bracket (create a window) when user logging data will be captured.  Only applies in Debug mode.  Maximum of 5 days from start time."
                    matTooltipPosition="below"
                    matTooltipHideDelay="2000"
                    matTooltipClass="hover-tooltip"
                    >
                    Log end:
                  </mat-label>
                </span>
                <p-inputNumber title="Day"    suffix="d" id="uledin-day"  class="startendinput" [(ngModel)]="teDays"  mode="decimal" value="0" showButtons="true" buttonLayout="vertical" min="0" max="999" width="40"></p-inputNumber>
                <p-inputNumber title="Hour"   suffix="h" id="uledin-hour" class="startendinput" [(ngModel)]="teHours" mode="decimal" value="0" showButtons="true" buttonLayout="vertical" min="0" max="24"  width="40"></p-inputNumber>
                <p-inputNumber title="Minute" suffix="m" id="uledin-min"  class="startendinput" [(ngModel)]="teMins"  mode="decimal" value="0" showButtons="true" buttonLayout="vertical" min="0" max="59"  width="40"></p-inputNumber>
                <p-inputNumber title="Second" suffix="s" id="uledin-sec"  class="startendinput" [(ngModel)]="teSecs"  mode="decimal" value="0" showButtons="true" buttonLayout="vertical" min="0" max="59"  width="40"></p-inputNumber>
              </div>
            </div>
            <div style="flex: 50%;">

              <div style="height: 20px;"></div>

              <div style="padding: 8px; width: 320px;">

                <!-- how long to run the simulation for -->
                <mat-label

                  matTooltip="Specify max number of days regarding how long to run the simulation for."
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                  >
                  Max Days:
                </mat-label>
                <input
                  id="simMaxDays"
                  type="number"
                  name="simMaxDays"
                  class="sim-max-days"
                  min="1"
                  max="9999"
                  [value]="maxDays"
                  (input)="maxDays = $event.target.value"
                  (change)="reconfigure()"
                  title="Maximum simulation days">

                <span style="width: 20px; display:inline-block;"></span>

                <!-- how long to wait for assuming lockup? -->
                <mat-label

                  matTooltip="Specify number of hours to wait for (assuming lockup)."
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                  >
                  Lockup Hours:
                </mat-label>
                <input
                  id="simLockupHours"
                  type="number"
                  name="simLockupHours"
                  class="sim-lockup-hours"
                  min="4"
                  max="1000"
                  [value]="lockupHours"
                  (change)="reconfigure()"
                title="Hours before lockup detection">

              </div>
              <div style="padding: 8px; width: 320px;">
                <!-- select verbosity level for logging -->
                <mat-label

                  matTooltip="Select verbosity level for logging."
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                  >
                  Log Level:
                </mat-label>
                <select
                  id="simLogLevel"
                  class="custom-select sim-log-level"
                  style="cursor: pointer;"
                  (change)="selectLogLevel($event) ; reconfigure()"
                  title="Logging verbosity">
                  <option value="debug">Debug</option>
                  <option value="info">Info</option>
                  <option value="notice">Notice</option>
                  <option value="warning">Warning</option>
                  <option value="error" selected="">Error</option>
                  <option value="critical">Critical</option>
                  <option value="alert">Alert</option>
                  <option value="emergency">Emergency</option>
                </select>

                <span style="width: 20px; display:inline-block;"></span>

                <!-- select the kind of dispatching to use -->
                <mat-label

                  matTooltip="Select the kind of dispatching to use."
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                  >
                  Dispatch:
                </mat-label>
                <select
                  id="simDispatch"
                  class="custom-select sim-dispatch"
                  style="cursor: pointer;"
                  (change)="selectDispatch($event); reconfigure()"
                  title="Dispatch logic to use">

                  <option value="workblox" selected="">Work Blocks</option>
                  <option value="rcm">RCM</option>
                  <option value="unconstrained">Unconstrained</option>

                </select>

              </div>
              <div style="padding: 8px; width: 320px;">

                <!-- allow permissive sim? -->
                <mat-label

                  matTooltip="Select whether or not to allow permissive simulation."
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                  >
                  Permissive:
                </mat-label>
                <input
                  id="simPermissive"
                  class="sim-permissive"
                  type="checkbox"
                  style="vertical-align: middle; display: inline-block; margin-top: -2px;"
                  [checked]="permissive"
                  (change)="permissive = !permissive; reconfigure()"
                  title="Permissive logic"
                />


                <span style="width: 20px; display:inline-block;"></span>
                <!-- automatically view the string line when done? -->
                <mat-label

                  matTooltip="Select whether or not to automatically view the string line when completed."
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                  >
                  Auto-View:
                </mat-label>
                <input
                  id="simAutoView"
                  class="sim-auto-view"
                  type="checkbox"
                  style="vertical-align: middle; display: inline-block;  margin-top: -2px;"
                  [checked]="autoview"
                  (change)="autoview = !autoview; reconfigure()"
                  title="Auto-View"
                />

              </div>

              <div style="padding: 8px; width: 320px;">

                <!-- how long to run the simulation for (wall clock time)-->
                <mat-label

                  matTooltip="Specify max number of seconds the simulator can run for (wall clock time)."
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                >
                  Max Time:
                </mat-label>

                <select
                  id="simMaxTime"
                  class="custom-select sim-max-time"
                  style="cursor: pointer;"
                  (change)="selectMaxTime($event) ; reconfigure()"
                  title="Maximum simulation runtime">
                  <option value="300"               >  5min </option>
                  <option value="600"               > 10min </option>
                  <option value="900"               > 15min </option>
                  <option value="1200"              > 20min </option>
                  <option value="1800"              > 30min </option>
                  <option value="2700"              > 45min </option>
                  <option value="3600" selected=""  >   1hr </option>
                  <option value="7200"              >   2hr </option>
                  <option value="10800"             >   3hr </option>
                  <option value="14400"             >   4hr </option>
                  <option value="18000"             >   5hr </option>
                  <option value="21600"             >   6hr </option>
                </select>

                <span style="width: 20px; display:inline-block;"></span>

                <!-- how long to run the simulation for (wall clock time)-->
                <mat-label

                  matTooltip="Specify max amount of RAM the simulation can take (in bytes)."
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                >
                  Max Memory:
                </mat-label>

                <select
                  id="simMaxMemory"
                  class="custom-select sim-max-memory"
                  style="cursor: pointer;"
                  (change)="selectMaxMemory($event) ; reconfigure()"
                  title="Maximum simulation RAM usage">
                  <option value="1073741824"             > 1G  </option>
                  <option value="2147483648" selected="" > 2G  </option>
                  <option value="3221225472"             > 3G  </option>
                  <option value="4294967296"             > 4G  </option>
                  <option value="5368709120"             > 5G  </option>
                  <option value="6442450944"             > 6G  </option>
                  <option value="7516192768"             > 7G  </option>
                  <option value="8589934592"             > 8G  </option>
                  <option value="9663676416"             > 9G  </option>
                  <option value="10737418240"            > 10G </option>
                  <option value="11811160064"            > 11G </option>
                  <option value="12884901888"            > 12G </option>
                  <option value="13958643712"            > 13G </option>
                  <option value="15032385536"            > 14G </option>
                  <option value="16106127360"            > 15G </option>
                  <option value="17179869184"            > 16G </option>
                  <option value="21474836480"            > 20G </option>
                  <option value="25769803776"            > 24G </option>
                  <option value="30064771072"            > 28G </option>
                  <option value="34359738368"            > 32G </option>
                </select>

              </div>

              <div style="padding: 8px; width: 320px;">
                <mat-label style="font-weight: bold;">Reaction Time</mat-label>
              </div>

              <div style="padding: 8px; width: 320px;">

                <!-- passenger train reaction time (seconds) -->

                <mat-label

                  matTooltip="Specify passenger train reaction time in seconds"
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                >
                  Passenger:
                </mat-label>
                <input
                  id="passengerReactionTime"
                  type="number"
                  name="passengerReactionTime"
                  class="passenger-reaction-time"
                  min="0"
                  max="86400"
                  [value]="passengerReactionTime"
                  (input)="passengerReactionTime = $event.target.value"
                  (change)="reconfigure()"
                  title="Passenger Train Reaction Time (sec)">
                <span style="margin-left: 6px; width: 20px; display:inline-block;">sec</span>
                <span style="width: 20px; display:inline-block;"></span>

                <!-- freight train reaction time (seconds) -->
                <mat-label

                  matTooltip="Specify freight train reaction time in seconds"
                  matTooltipPosition="below"
                  matTooltipHideDelay="2000"
                  matTooltipClass="hover-tooltip"
                >
                  Freight:
                </mat-label>
                <input
                  id="freightReactionTime"
                  type="number"
                  name="freightReactionTime"
                  class="freight-reaction-time"
                  min="0"
                  max="86400"
                  [value]="freightReactionTime"
                  (input)="freightReactionTime = $event.target.value"
                  (change)="reconfigure()"
                  title="Freight Train Reaction Time (sec)">
                <span style="margin-left: 6px; width: 20px; display:inline-block;">sec</span>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  `
})

/**
 *
 * @class SimulateButtonComponent
 *
 * @brief quick action to launch whatever simulation is in focus (or was last in focus)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class SimulateButtonComponent implements OnInit, OnDestroy, AfterViewInit {

  /** the kind of dispatch to use in the simulation */
  public       dispatch: string                = 'workblox';

  /** if simulations run in permissive mode */
  public     permissive: boolean               = true;

  /** auto-launch the string line viewer after the simulation? */
  public     autoview: boolean                 = false;

  /** how long to wait for lockup detection (hours) */
  public    lockupHours: number                = 48;

  /** max days to run the simulator for */
  public        maxDays: number                = 30;

  /** max simulation wall clock run time (seconds) */
  public        maxTime: number                = 3600;

  /** max simulation wall clock run time (seconds) */
  public        maxMemory: number                = 1024 * 1024 * 1024 * 6;

  /** the verbosity level for simulation logging */
  public       logLevel: string                = 'error';

  /** the passenger train reaction time (seconds) */
  public passengerReactionTime: number         = 0;

  /** the freight train reaction time (seconds) */
  public freightReactionTime: number           = 0;

  /** the remote simulator to use for actually doing the simulations */
  public       endpoint: string                = 'https://linesim.sn.ironroad.ca';

  /** the countdown to expiry */
  public simulationTitle: string                = 'No Simulation';

  /** change styling when we do or don't have a simulation we can run */
  public    activeClass: string                = 'inactive';

  public activeDebugClass: string              = 'inactive';

  /** the observable for what simulation is in focus */
  private simulationWatch: Subscription;

  /** the observable for what blob is in focus */
  private     blobWatch: Subscription;

  /** click Start/End to show/hide the user log start/end definition panel */
  public showOptions: boolean = false;

  /** the user log timing window (for debug mode) */

  public tsDays:  number = 0;
  public tsHours: number = 0;
  public tsMins:  number = 0;
  public tsSecs:  number = 0;

  public teDays:  number = 0;
  public teHours: number = 0;
  public teMins:  number = 0;
  public teSecs:  number = 0;

  /** the simulation currently in focus */
  private      simulation: SimulationGroupElement  = null;

  /** the blob (specific scenario) currently in focus */
  private          blob: BlobElement           = null;

  constructor(
    private ide:     IdeService,
    private uuid:    UUIDService,
    private linesim: LineSimService,
    private alerts:  AlertService,
    private actions: ActionService,
    private server:  ServerSideService
  ) {

    Logger.debug('[SimButton] constructing...');

    /* update the line simulation service with current GUI defaults */

    this.reconfigure();
  }

  /** limit the user logging window to whatever our maximum and ensure end is after start. */
  public normalize() {

    Logger.debug(`[SimButton] normalize() start: `, [this.tsDays, this.tsHours, this.tsMins, this.tsSecs]);
    Logger.debug(`[SimButton] normalize() end: `, [this.teDays, this.teHours, this.teMins, this.teSecs]);

    /* set minimum / maximum duration of debug window */

    let minDuration: number = 3600*6;    /* 6 hours */
    let maxDuration: number = 3600*24*5; /* 5 days  */

    /* the debug window can't start so far in that it goes past the end of the simulation */

    let maxStart: number    = (this.maxDays*24*3600) - maxDuration;

    /* convert both times to seconds */

    let start: number       = (this.tsDays * 86400) + (this.tsHours * 3600) + (this.tsMins * 60) + this.tsSecs;
    let end: number         = (this.teDays * 86400) + (this.teHours * 3600) + (this.teMins * 60) + this.teSecs;

    /* end has to be at least start */

    if (end < start) {

      end = start;
    }

    /* must have at least minimum window size */

    if ((end-start) < minDuration) {

      end = start + minDuration;
    }

    /* if It's too big, bring it back to maximum window size */

    if ((end-start) > maxDuration) {

      end = start + maxDuration;
    }

    /* start can not be later than the maximum start time (can't go past max days) */

    let duration: number = end - start;

    if (start > maxStart) {

      start = maxStart;
      end   = maxStart + duration;
    }

    /* convert seconds back to the inputs (start) */

    this.tsDays  = Math.floor(start / (3600*24));
    this.tsHours = Math.floor(start % (3600*24) / 3600);
    this.tsMins  = Math.floor(start % 3600 / 60);
    this.tsSecs  = Math.floor(start % 60);

    /* convert seconds back to the inputs (end) */

    this.teDays  = Math.floor(end / (3600*24));
    this.teHours = Math.floor(end % (3600*24) / 3600);
    this.teMins  = Math.floor(end % 3600 / 60);
    this.teSecs  = Math.floor(end % 60);
  }

  /** show/hide the user options/definition panel. */
  public toggleOptionsPanel() {

    if (this.showOptions) {

      this.showOptions = false;

      /*
       * we don't normalize anymore; just let the simulator error out if the range is bad
       *
      this.normalize();
       *
       */

    } else {

      this.showOptions = true;
    }

  }

  /**
   * when any of the quick configure parameters change, update the default parameters for the
   * line simulator service.
   */
  public reconfigure() {

    /* snapshot the launch parameters */

    let engine: string = $("#simSelector option:selected").text();

    const config: SimConfig = new SimConfig({
      dispatch:                SimConfig.dispatchType(this.dispatch),
      permissive:              this.permissive,
      autoview:                this.autoview,
      lockupHours:             this.lockupHours,
      maxDays:                 this.maxDays,
      maxTime:                 this.maxTime,
      maxMemory:               this.maxMemory,
      logLevel:                SimConfig.logLevelType(this.logLevel),
      passengerReactionTime:   this.passengerReactionTime,
      freightReactionTime:     this.freightReactionTime,
      endpoint:                SimConfig.endpointOfEngine(engine),
      engine
    });

    Logger.debug(`[SimButton] configuring line simulator service: `, config);

    /* tell the line simulator service there are new defaults */

    this.linesim.configure(config);

  }

  public isBusy(): boolean {

    return this.activeClass === 'busy';
  }

  /** @brief set up the dockable views and view manager */
  ngOnInit(): void {

    const sbc: SimulateButtonComponent = this;

    /* if an simulation is in context, we can simulate the simulation */

    sbc.simulationWatch = sbc.ide.activeSimulation
      .subscribe((simulation: SimulationGroupElement) => {

        if (simulation === sbc.simulation) {

          /* no change */

          return ;
        }

        sbc.simulation = simulation;
        sbc.blob     = null;

        sbc.update();
      });

    /* if a specific scenario is in context, we can simulate just that scenario */

    sbc.blobWatch = sbc.ide.activeBlob
      .subscribe((blob: BlobElement) => {

        if (blob === this.blob) {

          /* no change */

          return ;
        }

        sbc.blob       = blob;
        sbc.simulation = null;

        sbc.update();
      });

    /* the actions' manager know how to invoke this button */

    sbc.actions.add(new SimpleSimAction(() => {

      Logger.debug('[SimButton] manual launch ...');

      sbc.onClick();

    }));

    sbc.actions.add(new SimpleDebugAction(() => {

      Logger.debug('[SimButton] (Debug Mode) manual launch ...');

      sbc.onClick(true);

    }));

    /* set the possible remote simulators they can use ... */

    Logger.debug(`[SimButton] building simulation endpoints menu...`);

    /*
     * check the container's environment for additional configuration of remote
     * simulation engines...
     *
     */

    this.server.environmentVariables()
      .pipe(first())
      .subscribe({
        next: (content): void => {

          Logger.debug(`[SimButton] server side environment: `, content);

          /*
           * if they configured the container with the SIMULATION_ENGINES environment
           * variable, then we are redirecting one or more of the endpoints; likely for
           * local desktop development or testing.
           *
           */

          if (content.hasOwnProperty(`SIMULATION_ENGINES`)) {

            let urlMap: string = content[`SIMULATION_ENGINES`];

            /* allow SimConfig to pick up the redirects ... */

            SimConfig.overrideEndpoints(urlMap);
          }

          /*
           * now that we know the simulator endpoints are set, either default or overridden,
           * do the drop-down menu setup.
           *
           */

          const selector: JQuery = $(`#simSelector`);

          /* set the default URLs for the remote simulation engines.  */

          let endpoints: { name: string, url: string }[] = SimConfig.endpoints();

          Logger.debug(`[SimButton] remote simulation engine endpoints: `, endpoints);

          /* the first endpoint is the default to use */

          let o = new Option(endpoints[0].name, endpoints[0].url, true, true);

          $(o).html(endpoints[0].name);
          $(selector).append(o);

          sbc.endpoint = endpoints[0].url;

          sbc.reconfigure();

          endpoints.shift();

          /* just append the rest */

          endpoints.forEach((item: { name: string, url: string }) => {

            let o = new Option(item.name, item.url);

            $(o).html(item.name);
            $(selector).append(o);

          });

          /* if they have 'LINESIM_URL' defined, add it as a "local" endpoint */

          if (content.hasOwnProperty(`LINE_SIM_URL`)) {

            let url: string = content[`LINE_SIM_URL`];

            Logger.debug(`[SimButton] adding local endpoint: `, url);

            let o = new Option('local', url);

            $(o).html('local');
            $(selector).append(o);

          }

        },
        error: (err): void => {

          Logger.error(`[SimButton] problems fetching server side environment: `, errorAsText(err));

        }
      });

  }

  /** helper to fetch a legit value from a number input */
  public parseNumber(el: JQuery, min: number = 0, max: number  = 59) {

    if ($(el).val() === '') {

      $(el).val(min);

      return min;
    }

    let value: number  = parseInt($(el).val() as string, 10);

    if (isNaN(value)) {

      value = 0;
    }

    if (value < 0) {

      value *= -1;
    }

    if (value < min) {

      value = min;
    }

    if (value > max) {

      value = max;
    }

    /* reset the current value in the field */

    $(el).val(value);

    return value;
  }

  ngAfterViewInit(): void {

    const lockupHours: JQuery = $('.sim-lockup-hours');

    $(lockupHours).on('change', () => {

      this.lockupHours = this.parseNumber(lockupHours, 4, 1000);

    });

    const maxDays: JQuery = $('.sim-max-days');

    $(maxDays).on('change', () => {

      this.maxDays = this.parseNumber(maxDays, 1, 9999);

    });

    const maxTime: JQuery = $('.sim-max-time');

    $(maxTime).on('change', () => {

      this.maxTime = this.parseNumber(maxTime, 300, 21600);

    });

    const maxMemory: JQuery = $('.sim-max-memory');

    $(maxMemory).on('change', () => {

      this.maxMemory = this.parseNumber(maxMemory, 1024*1024*1024*2, 1024*1024*1024*32);

    });

    const passengerReactionTime: JQuery = $('.passenger-reaction-time');

    $(passengerReactionTime).on('change', (): void => {

      this.passengerReactionTime = this.parseNumber(passengerReactionTime, 0, 3600*24);

    });

    const freightReactionTime: JQuery = $('.freight-reaction-time');

    $(freightReactionTime).on('change', (): void => {

      this.freightReactionTime = this.parseNumber(freightReactionTime, 0, 3600*24);

    });

  }

  ngOnDestroy() {

    this.simulationWatch.unsubscribe();

    this.blobWatch.unsubscribe();
  }

  public selectSimulator(e: Event) {

    // @ts-ignore
    this.endpoint = e.target.value;

    Logger.debug('[SimButton] simulator selected: ', this.endpoint);

  }

  public selectDispatch(e: Event) {

    // @ts-ignore
    this.dispatch = e.target.value;
  }

  public selectLogLevel(e: Event) {

    // @ts-ignore
    this.logLevel = e.target.value;

  }

  public selectMaxMemory(e: Event) {

    // @ts-ignore
    this.maxMemory = e.target.value;

  }

  public selectMaxTime(e: Event) {

    // @ts-ignore
    this.maxTime = e.target.value;

  }

  update() {

    if ((this.simulation === null) && (this.blob === null)) {

      this.simulationTitle    = 'No Simulation / No Scenario';
      this.activeClass      = 'inactive';
      this.activeDebugClass = 'inactive';

      Logger.debug('[SimButton] INACTIVE: No Simulation.');
      return ;
    }

    this.activeDebugClass = 'inactive';

    if (this.blob !== null) {

      this.simulationTitle = this.blob._label;
      this.activeDebugClass = 'active';

    } else if (this.simulation !== null) {

      this.simulationTitle = this.simulation._label;
    }

    this.activeClass   = 'active';

    if (this.simulationTitle.length > 16) {

      this.simulationTitle = this.simulationTitle.substr(0, 16) + '...';
    }

    Logger.debug('[SimButton] ACTIVE: ' + this.simulationTitle);
  }

  getActiveClass() {

    return this.activeClass;
  }

  getSimulationTitle() {

    return this.simulationTitle;
  }

  getActiveDebugClass() {

    return this.activeDebugClass;
  }

  public onClick(debug: boolean = false) {

    if (this.activeClass === 'busy') {

      /* already launching something. */

      Logger.error('[SimButton] already launching, please wait...');

      return ;
    }

    /*
     * we don't normalize anymore; just let the simulator error out if the range is bad
     *
    this.normalize();
     */

    /* which simulation engine is being used? */

    let engineTag: string =  $("#simSelector option:selected").text();

    /* are doing a single simulation, or launching everything that is in a simulation? */

    if (this.blob !== null) {

      /* single sim mode, we support user logging for single sims */

      const sb: SimulateButtonComponent = this;
      const be: BlobElement             = sb.blob;

      const config: SimConfig           = new SimConfig({
        dispatch:              SimConfig.dispatchType(sb.dispatch),
        maxDays:               sb.maxDays,
        maxTime:               sb.maxTime,
        maxMemory:             sb.maxMemory,
        lockupHours:           sb.lockupHours,
        logLevel:              SimConfig.logLevelType(sb.logLevel),
        permissive:            sb.permissive,
        priority:              1.0,
        autoview:              sb.autoview,
        userlog:               '',
        traceStart:            '',
        traceEnd:              '',
        passengerReactionTime: sb.passengerReactionTime,
        freightReactionTime:   sb.freightReactionTime,
        engine:                engineTag,
        endpoint:              SimConfig.endpointOfEngine(engineTag)
      });

      if (debug) {

        /*
         * when debugging they MUST be using the simulator configured when the image
         * was deployed; i.e. whatever simulator is included in the local "docker compose"
         * deployment.  This is necessary because for the line simulator to be sending
         * data to MongoDB ... the huge volume of user logging stuff...they have to both
         * be in the same cluster.  We don't expose mongodb outside the cluster, so in
         * debug mode, the ONLY option is to also use teh simulator (likely "stand alone"
         * line simulator) that is in the same docker compose cluster.
         *
         * The important part here, is that we ensure no endpoint is set, and we aren't
         * overriding whatever the default is.
         *
         */

        config.endpoint = SimConfig.endpointOfEngine(engineTag);
        config.engine   = engineTag;

        /* they clicked the Debug button, enable user logging... */

        config.userlog    = 'mongodb://mongo:mongo@mongodb:27017/linesim';
        config.traceStart = asISO8601(this.tsDays, this.tsHours, this.tsMins, this.tsSecs);
        config.traceEnd   = asISO8601(this.teDays, this.teHours, this.teMins, this.teSecs);

        Logger.debug('[SimButton] (Debug Mode) launching...', config);

      } else {

        Logger.debug('[SimButton] launching...', config);
      }

      this.activeClass = 'busy';

      be.busy();

      this.linesim.singleSim(be, config).then((result: LineSimJobElement) => {

        /* we can't unbusy(), the result element must do it when its downloaded the results */

        sb.activeClass      = 'active';
        sb.activeDebugClass = 'active';

        Logger.debug(`[SimButton] launched ${result._job.id()}: `, result);

        result.taskUpdate(`Launched ${basename(result._blobKey)}...please wait...`);

        /* make sure the thing we just created is visible */

        result._project.expand([result._parent]);

        setTimeout((): void => {

          result._expanded = false;

          result._project.collapse([result, ...result.children()]);

          result.save();

        }, 600);

      }, (error) => {

        be.unBusy();
        sb.activeClass      = 'active';
        sb.activeDebugClass = 'active';

        this.alerts.error(`Can't launch job: ` + errorAsText(error));

        Logger.error(`[SimButton] can't launch job: `, errorAsText(error));

      }).catch((error) => {

        be.unBusy();
        sb.activeClass      = 'active';
        sb.activeDebugClass = 'active';

        this.alerts.error(`Can't launch job: ` + errorAsText(error));

        Logger.error(`[SimButton] can't launch job: `, errorAsText(error));
      });

    } else if (this.simulation !== null) {

      /*
       * batch mode; note that this is the legacy "fire and forget" implementation
       * of batch mode.  Not intended for user logging, and intended to be replaced
       * by the scalable work engine.
       *
       */

      /*
       * find all the Scenario's that we can simulate from this simulation; that is:
       *
       *  - any immediate child of Inputs
       *  - any immediate child of a Scenario Dimension
       *
       */

     let scenarios: BlobElement[] = [];

     this.simulation.descendants(ProjectElementType.Inputs).forEach((el: InputsElement) => {

       el.children().forEach((kid: ProjectElement) => {

         if (kid._type === ProjectElementType.Blob) {

           /* any blob under Inputs, is a scenario */

           scenarios.push(kid as BlobElement);

         } else if (kid._type !== ProjectElementType.Dimension) {

           return ;
         }

         /* if we found a dimension, confirm that its casting stuff to Plant (scenario) */

         const dim: DimensionElement = kid as DimensionElement;

         if ((dim.dimKind !== BlobType.Plant) && (dim.dimKind !== BlobType.Scenario)) {

           return ;
         }

         /* any blob children of an input dimension, are to be taken as scenarios. */

         dim.children().forEach((item: ProjectElement) => {

           if (item._type !== ProjectElementType.Blob) {

             return ;
           }

           scenarios.push(item as BlobElement);
         });

       })

     });

     /*
      * filter out any that already have a valid result, we want to allow for things to fail,
      * and when they do, just let the user keep trying until they get a complete set of
      * simulations, but for that to NOT be a never ending loop, the remainder must be
      * getting smaller every round, to guarantee that, in this batch mode, we only simulate
      * stuff that doesn't already have a valid result.
      *
      */

      scenarios = scenarios.filter((item: BlobElement) => {

        if (item._children.length === 0) {

          /* no results (pass or fail) yet */

          return true;
        }

        const results: ProjectElement[] = item._children.filter((kid:ProjectElement) => {

          if (kid._type !== ProjectElementType.LineSimResult) {

            /* it's not a simulation result */

            return false;
          }

          const result: LineSimJobElement = kid as LineSimJobElement;

          if (result._job.complete() !== true) {

            /* its a result, but in whatever way, didn't get to COMPLETE status */

            return false;
          }

          /* this is a valid result */

          return true;
        });

        /* if it has no *valid* results, we need to simulate */

        if (results.length === 0) {

          return true;
        }

        /* it has at least one valid result, we will skip this one. */

        return false;
      });

     /* do we actually have anything to simulate? */

     if (scenarios.length === 0) {

       /* nothing to do, no input scenarios */

       Logger.error(`[SimButton] (sim all) simulation has no input scenarios`, this.simulation);

       return ;
     }

     /*
      * the 'launch' is a web request, just like blobmanager requests such as delete or
      * update.  So, we do the same thing here for batch processing, lock the screen,
      * and track the progress of doing a big for and join for the launch on each
      * scenario.
      *
      */

      Logger.debug(`[SimButton] (sim all) launching simulations: `, scenarios);

      const sb: SimulateButtonComponent = this;

      /* NOTE: in batch mode we force auto-view to be off, so they don't blast their browser's RAM */

      const config: SimConfig           = new SimConfig({
        dispatch:              SimConfig.dispatchType(sb.dispatch),
        maxDays:               sb.maxDays,
        maxTime:               sb.maxTime,
        maxMemory:             sb.maxMemory,
        lockupHours:           sb.lockupHours,
        logLevel:              SimConfig.logLevelType(sb.logLevel),
        permissive:            sb.permissive,
        priority:              1.0,
        autoview:              false,
        userlog:               '',
        traceStart:            '',
        traceEnd:              '',
        passengerReactionTime: sb.passengerReactionTime,
        freightReactionTime:   sb.freightReactionTime,
        engine:                engineTag,
        endpoint:              SimConfig.endpointOfEngine(engineTag)
      });

      this.linesim.multiSim(scenarios, config).then((results: LineSimJobElement[]) => {

        Logger.debug(`[SimButton] simulations launched: `, results);

        /* make sure the thing we just created is visible */

        results.forEach((el: LineSimJobElement) => {

          el.taskUpdate(`Launched ${basename(el._blobKey)}...please wait...`);

          /* we save all project changes at the end */

          el._parent.skipSave(true);
          el._project.expand([el._parent]);
        });

        /* make sure the project is saved */

        sb.simulation.save();

      }, (error) => {

        this.alerts.error(`Can't launch job: ` + errorAsText(error));

        Logger.error(`[SimButton] can't launch job: `, errorAsText(error));

      }).catch((error) => {

        this.alerts.error(`Can't launch job: ` + errorAsText(error));

        Logger.error(`[SimButton] can't launch job: `, errorAsText(error));
      });

    }
  }
}
